import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { t, t2 } from '@/@core/libs/i18n/utils'
import { $themeConfig } from '@themeConfig'

export default function tableShareTargetTransactionList() {
  // Use toast
  const toast = useToast()

  const refShareTargetTransactionListTable = ref(null)

  const msgList = {
    errorfetch: t2('Error fetching {module} list', { module: t('ShareTargetTransaction') }),
    create_datetime: `${t('Date/Time')} » ${t('ID')}`,
    line_user: `${t('Line User')} » ${t('ID')}`,
    sharetarget: `${t('Message')} » ${t('Link')}`,
    result: `${t('Result')}`,
    actions: t('Actions'),
  }

  // Table Handlers
  const tableColumns = [
    { key: 'create_datetime', sortable: true, label: msgList.create_datetime },
    { key: 'line_user', sortable: false, label: msgList.line_user },
    { key: 'sharetarget', sortable: false, label: msgList.sharetarget },
    { key: 'result', sortable: false, label: msgList.result },
    { key: 'actions', label: msgList.actions },
  ]

  const perPage = ref(10)
  const totalShareTargetTransactions = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [2, 5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('create_datetime')
  const isSortDirDesc = ref(true)
  const locale = ref('th')
  const nameFilter = ref('')

  const dataMeta = computed(() => {
    const localItemsCount = refShareTargetTransactionListTable.value ? refShareTargetTransactionListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalShareTargetTransactions.value,
    }
  })

  const refetchData = () => {
    refShareTargetTransactionListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, locale, nameFilter], () => {
    refetchData()
  })

  const getListShareTargetTransaction = (ctx, callback) => {
    const params = {
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      language: locale.value,
      name: nameFilter.value,
    }
    store
      .dispatch('sharetarget-transaction-store/getListShareTargetTransaction', params)
      .then(response => {
        const { list, total } = response.data
        callback(list)
        totalShareTargetTransactions.value = total
        localStorage.setItem(`${$themeConfig.app.session}-filter-share-target-transaction-list`, JSON.stringify(params))
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: msgList.errorfetch,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        },
        {
          position: 'bottom-right',
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const isResultVariant = data => {
    if (data.is_sended === '1') return 'success'
    if (data.is_canceled === '1') return 'danger'
    return 'secondary'
  }

  const isResultToText = data => {
    if (data.is_sended === '1') return 'Sended'
    if (data.is_canceled === '1') return 'Canceled'
    return ''
  }
  const textFirstUpper = text => text.slice(0, 1).toUpperCase() + text.slice(1, text.length)

  return {
    getListShareTargetTransaction,
    tableColumns,
    perPage,
    currentPage,
    totalShareTargetTransactions,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    locale,
    refShareTargetTransactionListTable,

    refetchData,
    isResultVariant,
    isResultToText,
    textFirstUpper,

    nameFilter,
  }
}
